/**
 * Cause d'un échec d'`updateAppConfig` (API `app-config.service.ts`), pour dire
 * à l'administrateur QUEL champ bloque : un asset trop lourd déjà en base (#15)
 * ou un couple couleur / encre illisible (#99) peuvent faire échouer un
 * enregistrement sur un champ qu'il n'a pas touché.
 */
export type BrandingSaveError
  = | { kind: 'assetTooLarge', asset: 'favicon' | 'logo' }
    | { kind: 'inkTooLow', color: 'primary' | 'accent' }
    | { kind: 'unknown' }

const CAUSES: Record<string, BrandingSaveError> = {
  FAVICON_TOO_LARGE: { kind: 'assetTooLarge', asset: 'favicon' },
  LOGO_TOO_LARGE: { kind: 'assetTooLarge', asset: 'logo' },
  PRIMARY_CONTRAST_TOO_LOW: { kind: 'inkTooLow', color: 'primary' },
  ACCENT_CONTRAST_TOO_LOW: { kind: 'inkTooLow', color: 'accent' },
}

export function brandingSaveError(error: unknown): BrandingSaveError {
  const message = error instanceof Error ? error.message : ''
  const code = Object.keys(CAUSES).find(key => message.includes(key))
  return code ? CAUSES[code]! : { kind: 'unknown' }
}
